const dataToArray = (obj, originalObj) => {
  let rows = Array.isArray(obj) ? obj : [ [obj, originalObj] ]
  let result = []
  for (let r of rows) {
    let item, original
    if (Array.isArray(r)) {
      item = r[0]
      original = r.length === 2 && r[1]
    } else {
      item = r
    }

    result.push({ item, original })
  }

  return result
}

export default dataToArray
